import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  // Подключаем backend для загрузки переводов
  .use(Backend)
  // Подключаем детектор языка
  .use(LanguageDetector)
  // Подключаем react-i18next
  .use(initReactI18next)
  // Инициализируем i18next
  .init({
    // Резервный язык, если перевод не найден
    fallbackLng: "en",

    // Языки по умолчанию для отладки
    debug: import.meta.env.MODE === "development",

    // Интерполяция
    interpolation: {
      escapeValue: false, // React уже экранирует значения
    },

    // Настройки backend для загрузки переводов
    backend: {
      // Путь к файлам переводов с timestamp для принудительного обновления
      loadPath: `/locales/{{lng}}/{{ns}}.json?t=${Date.now()}`,

      // Отключаем кэширование для разработки
      requestOptions: {
        cache: "no-cache",
      },

      // Кэшировать загруженные ресурсы
      allowMultiLoading: false,

      // Время кэширования (1 минута для разработки)
      expirationTime: 60 * 1000,
    },

    // Настройки детектора языка
    detection: {
      // Explicit landing language takes precedence when entering the app.
      order: ["querystring", "localStorage"],
      lookupQuerystring: "lng",

      // Кэшируем выбранный язык в localStorage
      caches: ["localStorage"],

      // Ключ для сохранения в localStorage
      lookupLocalStorage: "i18nextLng",
    },

    // Пространства имен (namespaces) - только для клиентского приложения
    ns: [
      "common",
      "home",
      "auth",
      "profile",
      "payments",
      "texts",
      "practice",
      "progress",
      "dictation",
      "dictionary",
      "quickstart",
      "navigation",
      "plans",
      "legal",
    ],
    defaultNS: "common", // Только для общеупотребительных элементов

    // Fallback namespaces - если ключ не найден в defaultNS, ищем в других
    fallbackNS: false, // Отключаем fallback namespaces - используем только fallback язык

    // Предзагрузка всех необходимых namespaces
    preload: ["en"], // Предзагружаем только английский как fallback

    // Поддерживаемые языки
    supportedLngs: [
      "en",
      "it",
      "es",
      "de",
      "fr",
      "ru",
      "pl",
      "uk",
      "el",
      "zh",
      "tr",
      "ja",
      "ko",
    ],

    // Не загружать переводы для неподдерживаемых языков
    nonExplicitSupportedLngs: false,

    // Настройки React
    react: {
      // Не использовать Suspense по умолчанию
      useSuspense: false,

      // Перерисовываем компоненты при смене языка И при добавлении новых переводов в стор.
      // bindI18nStore: "added" нужен для ленивой загрузки: changeLanguage() загружает файлы
      // асинхронно и добавляет их в стор уже после первого ре-рендера. Без этого компонент
      // остаётся с английским текстом пока пользователь не вызовет ещё один ре-рендер.
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added",
    },

    // Кэширование ресурсов
    saveMissing: false, // Не сохранять недостающие переводы
    updateMissing: false, // Не обновлять недостающие переводы

    // Настройки загрузки
    load: "languageOnly", // Загружать только основной язык (без региональных вариантов)
    cleanCode: true, // Очищать коды языков
  });

export default i18n;
